module.exports = __webpack_public_path__ + "static/media/feeslogo.582210cb.svg";